import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import {
  StyledErrorLabel,
  StyledUnOrderedList,
  StyledListItem,
  Button
} from '../../styles/StyledElements'
import FlexBox from '../../FlexBox'

function StripeErrorsModal(props) {
  const { errors = [], showValidationErrors, isMobile } = props

  return(
    <Dialog
      open={errors.length > 0 && showValidationErrors}
      onClose={() => props.onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={false}
      fullWidth={false}
    >
      <DialogContent>
        <FlexBox
          direction="column"
          alignItems="center"
          justify="center"
          textAlign="center"
          padding="0.5rem 1.5rem"
        >
          <DialogContentText id="alert-dialog-description">
            <StyledErrorLabel color="red" fontSize={24} fontWeight={800}>
              You're missing some information.
            </StyledErrorLabel>
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            <StyledUnOrderedList color='red'>
              {errors.map((message) => {
                  return message ?
                    <StyledListItem>
                    {message || null}
                  </StyledListItem>
                  : null
              })}
            </StyledUnOrderedList>
          </DialogContentText>
          <DialogActions className="vouched-dialog-action">
            <Button
              padding={ !isMobile ? '0.5em 4em' : '0.5em 1em'}
              marginTop="1rem"
              twistedBrown
              onClick={() => {
                props.onClose()
              }}
              disabled={false}
            >
              Got it, Thanks
            </Button>
          </DialogActions>
        </FlexBox>
      </DialogContent>
    </Dialog>
  )
}

export default StripeErrorsModal